export const heroSlides = [
  {
    id: 1,
    title: '2024最新日剧推荐',
    subtitle: '高分日剧一网打尽，随时随地免费看',
    image: 'https://sakuraon.github.io/api/search-image?query=Modern%20Japanese%20living%20room%20with%20large%20TV%20screen%20displaying%20Japanese%20drama%20scene%2C%20warm%20tatami%20floor%2C%20minimalist%20interior%2C%20soft%20ambient%20lighting%20from%20paper%20lantern%2C%20cozy%20evening%20atmosphere%2C%20cinematic%20color%20grading%20with%20warm%20tones%2C%20editorial%20photography%2C%20clean%20composition&width=1600&height=900&seq=hero-2024-drama&orientation=landscape',
    link: '/category/drama',
  },
  {
    id: 2,
    title: '热门动漫新番上线',
    subtitle: '每周更新，追番不等待',
    image: 'https://sakuraon.github.io/api/search-image?query=Stylized%20Japanese%20anime%20art%20style%20wallpaper%20with%20vibrant%20celestial%20sky%2C%20cherry%20blossom%20petals%20floating%2C%20modern%20Tokyo%20skyline%20silhouette%20at%20sunset%2C%20warm%20golden%20and%20pink%20gradient%2C%20dreamy%20atmosphere%2C%20clean%20artistic%20background%2C%20minimal%20illustration%20style&width=1600&height=900&seq=hero-2024-anime&orientation=landscape',
    link: '/category/anime',
  },
  {
    id: 3,
    title: '经典日本电影回顾',
    subtitle: '从黑泽明到是枝裕和，经典永流传',
    image: 'https://sakuraon.github.io/api/search-image?query=Cinematic%20Japanese%20film%20scene%20aesthetic%2C%20vintage%20movie%20theater%20with%20red%20curtains%2C%20warm%20theater%20lighting%2C%20classic%20Japanese%20film%20posters%20on%20wall%2C%20nostalgic%20atmosphere%2C%20golden%20hour%20light%20streaming%20through%20windows%2C%20elegant%20composition%2C%20film%20noir%20inspired&width=1600&height=900&seq=hero-2024-movie&orientation=landscape',
    link: '/category/movie',
  },
];

export const categories = [
  {
    slug: 'drama',
    name: '日剧',
    icon: 'ri-tv-line',
    description: '最新日剧、经典日剧高清在线观看',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20television%20drama%20scene%20with%20modern%20Tokyo%20apartment%20setting%2C%20two%20actors%20in%20conversation%2C%20warm%20interior%20lighting%2C%20cinematic%20mood%2C%20minimal%20Japanese%20decor%2C%20soft%20depth%20of%20field%2C%20editorial%20style%20photography&width=600&height=400&seq=cat-drama-01&orientation=landscape',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-film-line',
    description: '热血、治愈、悬疑各类动漫免费看',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20anime%20style%20illustration%20with%20vibrant%20colors%2C%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20traditional%20Japanese%20temple%20in%20background%2C%20soft%20dreamy%20lighting%2C%20clean%20artistic%20composition%2C%20warm%20spring%20atmosphere&width=600&height=400&seq=cat-anime-01&orientation=landscape',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '日本搞笑综艺、真人秀欢乐不断',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20variety%20show%20TV%20studio%20with%20colorful%20set%20design%2C%20bright%20studio%20lights%2C%20entertainment%20atmosphere%2C%20modern%20Japanese%20TV%20production%2C%20vibrant%20colors%2C%20wide%20angle%20shot%2C%20professional%20studio%20photography&width=600&height=400&seq=cat-variety-01&orientation=landscape',
  },
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '日本电影大片随时随地在线播放',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20cinema%20exterior%20with%20vintage%20movie%20posters%2C%20neon%20signs%20in%20Shibuya%20style%2C%20evening%20cityscape%2C%20warm%20ambient%20night%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20cinematic%20photography%2C%20atmospheric&width=600&height=400&seq=cat-movie-01&orientation=landscape',
  },
];

export const hotRecommendations = [
  {
    id: 1,
    title: '重启人生',
    category: 'drama',
    categoryName: '日剧',
    rating: 9.4,
    year: '2023',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20drama%20poster%20style%20with%20young%20woman%20looking%20thoughtful%20in%20modern%20Tokyo%20cafe%2C%20warm%20cinematic%20lighting%2C%20minimal%20poster%20design%2C%20soft%20bokeh%20background%2C%20elegant%20portrait%20photography&width=400&height=560&seq=hot-reborn&orientation=portrait',
    description: '平凡上班族意外获得重生机会，一次次重新来过的人生故事',
    featured: true,
  },
  {
    id: 2,
    title: '咒术回战 第二季',
    category: 'anime',
    categoryName: '动漫',
    rating: 9.2,
    year: '2023',
    image: 'https://sakuraon.github.io/api/search-image?query=Anime%20style%20poster%20with%20dynamic%20action%20pose%2C%20dark%20urban%20fantasy%20setting%2C%20dramatic%20lighting%20with%20blue%20and%20orange%20contrast%2C%20clean%20illustration%20style%2C%20cinematic%20composition%2C%20intense%20atmosphere&width=400&height=560&seq=hot-jjk&orientation=portrait',
    description: '涩谷事变篇震撼来袭，咒术师与咒灵的大战全面爆发',
    featured: true,
  },
  {
    id: 3,
    title: '月曜夜未央',
    category: 'variety',
    categoryName: '综艺',
    rating: 9.6,
    year: '2024',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20variety%20show%20promotional%20poster%20with%20bright%20colorful%20graphic%20design%2C%20bold%20typography%2C%20fun%20and%20playful%20style%2C%20TV%20show%20aesthetic%2C%20clean%20minimal%20background%2C%20vibrant%20pop%20art%20inspired&width=400&height=560&seq=hot-getsuyou&orientation=portrait',
    description: '深夜档人气综艺，松子和村上的绝妙搭档带来无限欢乐',
    featured: true,
  },
  {
    id: 4,
    title: '怪物',
    category: 'movie',
    categoryName: '电影',
    rating: 8.9,
    year: '2023',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20film%20poster%20with%20mysterious%20atmosphere%2C%20two%20children%20standing%20in%20school%20corridor%2C%20dramatic%20lighting%20from%20window%2C%20cinematic%20composition%2C%20minimal%20design%2C%20thought-provoking%20mood%2C%20art%20house%20film%20aesthetic&width=400&height=560&seq=hot-monster&orientation=portrait',
    description: '是枝裕和导演作品，戛纳最佳编剧奖获奖影片',
    featured: true,
  },
  {
    id: 5,
    title: 'VIVANT',
    category: 'drama',
    categoryName: '日剧',
    rating: 9.0,
    year: '2023',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20action%20drama%20poster%20with%20man%20in%20desert%20landscape%2C%20dramatic%20sky%2C%20epic%20scale%2C%20cinematic%20lighting%2C%20movie%20poster%20style%2C%20adventure%20theme%2C%20warm%20golden%20tones&width=400&height=560&seq=hot-vivant&orientation=portrait',
    description: '堺雅人主演，跨越国界的大型谍战悬疑剧',
    featured: false,
  },
  {
    id: 6,
    title: '葬送的芙莉莲',
    category: 'anime',
    categoryName: '动漫',
    rating: 9.3,
    year: '2023',
    image: 'https://sakuraon.github.io/api/search-image?query=Anime%20poster%20with%20elf%20character%20in%20fantasy%20landscape%2C%20beautiful%20meadow%20with%20wildflowers%2C%20soft%20golden%20sunset%20lighting%2C%20gentle%20and%20emotional%20atmosphere%2C%20clean%20illustration%2C%20fantasy%20adventure%20theme&width=400&height=560&seq=hot-frieren&orientation=portrait',
    description: '勇者小队归来后的精灵魔法使，踏上理解人类的旅程',
    featured: false,
  },
  {
    id: 7,
    title: '地面师',
    category: 'movie',
    categoryName: '电影',
    rating: 8.5,
    year: '2024',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20crime%20thriller%20poster%20with%20urban%20night%20scene%2C%20man%20in%20suit%20standing%20in%20Tokyo%20alley%2C%20neon%20reflections%2C%20noir%20lighting%2C%20tense%20atmosphere%2C%20cinematic%20film%20poster%20design&width=400&height=560&seq=hot-jimenshi&orientation=portrait',
    description: '绫野刚主演，揭露日本房地产诈骗黑幕的犯罪悬疑片',
    featured: false,
  },
  {
    id: 8,
    title: '水曜日的DOWNTOWN',
    category: 'variety',
    categoryName: '综艺',
    rating: 9.5,
    year: '2024',
    image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20comedy%20variety%20show%20poster%20with%20two%20comedians%2C%20bright%20studio%20lighting%2C%20bold%20yellow%20and%20red%20graphic%20design%20elements%2C%20fun%20atmosphere%2C%20TV%20promotional%20style%2C%20clean%20composition&width=400&height=560&seq=hot-downtown&orientation=portrait',
    description: 'DOWNTOWN主持的人气综艺，各种搞笑企划让你笑到停不下来',
    featured: false,
  },
];

export const latestUpdates = [
  { id: 1, title: '如虎添翼', category: 'drama', categoryName: '日剧', episode: '第12集', updateTime: '2小时前', image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20morning%20drama%20scene%20with%20vintage%20Showa%20era%20courtroom%2C%20woman%20lawyer%20in%20traditional%20court%20attire%2C%20warm%20nostalgic%20lighting%2C%20period%20drama%20aesthetic%2C%20cinematic%20still%2C%20historical%20setting&width=400&height=260&seq=latest-tora&orientation=landscape' },
  { id: 2, title: '鬼灭之刃 柱训练篇', category: 'anime', categoryName: '动漫', episode: '第5集', updateTime: '5小时前', image: 'https://sakuraon.github.io/api/search-image?query=Anime%20style%20training%20scene%20in%20forest%20setting%2C%20dynamic%20action%20pose%2C%20traditional%20Japanese%20architecture%20background%2C%20warm%20sunlight%20through%20trees%2C%20vibrant%20colors%2C%20cinematic%20animation%20still&width=400&height=260&seq=latest-kny&orientation=landscape' },
  { id: 3, title: 'Ametalk', category: 'variety', categoryName: '综艺', episode: '最新期', updateTime: '8小时前', image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20talk%20show%20studio%20set%20with%20comedians%20sitting%20on%20sofa%2C%20bright%20colorful%20set%20design%2C%20professional%20TV%20lighting%2C%20entertainment%20atmosphere%2C%20wide%20studio%20shot&width=400&height=260&seq=latest-ametalk&orientation=landscape' },
  { id: 4, title: '完美的日子', category: 'movie', categoryName: '电影', episode: '高清版', updateTime: '12小时前', image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20film%20still%20showing%20man%20cleaning%20public%20toilet%20in%20Tokyo%20park%2C%20morning%20sunlight%20through%20trees%2C%20contemplative%20mood%2C%20Wim%20Wenders%20film%20aesthetic%2C%20warm%20natural%20lighting%2C%20minimal%20composition&width=400&height=260&seq=latest-perfect&orientation=landscape' },
  { id: 5, title: '不合时宜的我们', category: 'drama', categoryName: '日剧', episode: '第8集', updateTime: '1天前', image: 'https://sakuraon.github.io/api/search-image?query=Japanese%20romance%20drama%20scene%20with%20couple%20walking%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%2C%20cinematic%20lighting%2C%20romantic%20mood%2C%20warm%20golden%20hour&width=400&height=260&seq=latest-futeki&orientation=landscape' },
  { id: 6, title: '迷宫饭', category: 'anime', categoryName: '动漫', episode: '第18集', updateTime: '1天前', image: 'https://sakuraon.github.io/api/search-image?query=Anime%20style%20fantasy%20cooking%20scene%20in%20dungeon%20setting%2C%20adventurers%20gathered%20around%20campfire%2C%20delicious%20monster%20cuisine%2C%20warm%20fire%20glow%2C%20detailed%20food%20illustration%2C%20cozy%20atmosphere&width=400&height=260&seq=latest-dungeon&orientation=landscape' },
];

export const faqItems = [
  {
    question: '日本在线观看需要下载软件吗？',
    answer: '完全不需要！我们的日本在线观看平台支持网页直接播放，手机、电脑、平板均可流畅观看，无需下载任何软件或插件，打开浏览器即可享受高清日本影视内容。',
  },
  {
    question: '日本电影在线观看的画质如何？',
    answer: '我们提供的日本电影在线观看资源均为高清画质，大部分内容支持1080P甚至4K分辨率。我们持续优化播放体验，确保您在观看日本电影时获得最佳视觉效果。',
  },
  {
    question: '日剧在线观看免费资源多久更新一次？',
    answer: '日剧在线观看免费资源每日更新！我们的内容团队实时跟进日本播出进度，热门日剧通常在播出后24小时内即可在我们的平台免费观看，确保您不会错过任何精彩内容。',
  },
  {
    question: '日本动漫在线观看支持哪些设备？',
    answer: '日本动漫在线观看全面支持所有主流设备，包括Windows/Mac电脑、iPhone/Android手机、iPad/Android平板等。自适应播放技术会根据您的网络状况自动调整画质，确保流畅观看体验。',
  },
  {
    question: '日本综艺在线观看有中文字幕吗？',
    answer: '是的，我们的日本综艺在线观看资源均配备高质量中文字幕。专业字幕团队精心翻译，确保您能准确理解每一个笑点和梗，享受原汁原味的日本综艺乐趣。',
  },
  {
    question: '如何搜索想看的日本剧集在线观看？',
    answer: '您可以通过页面顶部的搜索功能，或使用分类筛选功能快速找到想看的日本剧集。我们提供按类型、年份、评分等多种筛选方式，帮助您高效发现感兴趣的日本影视内容。',
  },
];

export const siteStats = [
  { label: '影视资源', value: '10,000+' },
  { label: '每日更新', value: '50+' },
  { label: '活跃用户', value: '500万+' },
  { label: '高清画质', value: '1080P+' },
];